import { CountUp } from 'countup.js';

var mumimos = $('.mumimo');

mumimos.each(function (index, mumimo) {
    var svg = $('svg', mumimo);

    if (svg.length > 0) {
        var paths = $('.animate', svg),
            countUp = $('.mumimo-count-up', mumimo),
            waypoints = [],
            lineDuration = 1000,
            lineBaseDelay = 200,
            lineDelays = 0,
            totalDuration,
            animating = false,
            timeout;

        paths.each(function (index, path) {
            var delay = lineBaseDelay * index;
            lineDelays = lineDelays + delay;

            // Set initial stroke properties using anime.js
            anime.set(path, {
                strokeDasharray: path.getTotalLength(),
                strokeDashoffset: path.getTotalLength()
            });

            $(path).on('play', function () {
                $(path).addClass('js-animate');
                anime({
                    targets: path,
                    strokeDashoffset: 0,
                    duration: lineDuration,
                    delay: delay,
                    easing: 'linear',
                    complete: function () {
                        var linkedTo = $(path).data('linked-to');
                        if (linkedTo != null) {
                            linkedTo = $('#' + linkedTo);
                            if (linkedTo.length > 0) {
                                linkedTo.addClass('js-activated');
                            }
                        }
                    }
                });
            });

            $(path).on('stop', function () {
                anime.set(path, {
                    strokeDasharray: path.getTotalLength(),
                    strokeDashoffset: path.getTotalLength()
                });
                $(path).removeClass('js-animate');
            });
        });

        totalDuration = lineDuration + lineDelays;

        countUp.each(function (index, element) {
            var countTo = $(element).data('count-to'),
                counter = new CountUp(element, countTo, {
                    duration: totalDuration / 1000,
                    separator: '.'
                });

            $(element).on('start', function () {
                counter.start();
            });

            $(element).on('reset', function () {
                counter.reset();
            });
        });

        $(mumimo).on('start', function () {
            if (animating === false) {
                animating = true;
                paths.trigger('play');
                countUp.trigger('start');
            }
        });

        $(mumimo).on('stop', function () {
            if (animating === true) {
                animating = false;
                paths.trigger('stop');
                countUp.trigger('reset');
                clearTimeout(timeout);
            }
        });

        waypoints = [
            new Waypoint({
                continuous: false,
                element: $('svg', mumimo)[0],
                handler: function (direction) {
                    if (direction === 'up') {
                        $(mumimo).trigger('start');
                    }
                }
            }),
            new Waypoint({
                continuous: false,
                element: mumimo,
                handler: function (direction) {
                    $(mumimo).trigger('start');
                },
                offset: 'bottom-in-view'
            }),
            new Waypoint({
                continuous: false,
                element: mumimo,
                handler: function (direction) {
                    if (direction === 'down') {
                        $(mumimo).trigger('stop');
                    }
                },
                offset: -mumimo.clientHeight
            }),
            new Waypoint({
                continuous: false,
                element: mumimo,
                handler: function (direction) {
                    if (direction === 'up') {
                        $(mumimo).trigger('stop');
                    }
                },
                offset: mumimo.clientHeight
            })
        ];
    }
});
